import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import { motion } from "framer-motion";
import DotsVerticalIcon from "../../../component/icons/dots-vertical";
import { TableCard } from "../../../component/table/table-layout";
import DealList from "./Deals";
import StatusChip from "../../../component/ui/chip/status";
import { ChevronRight, NotebookText, ThumbsUp } from "lucide-react";
import DragCarousel from "./DragCrousal";
import ProjectQuickView from "../../mainProjects/projects/project/popup";
// import ProjectQuickView from "../../projects/project/popup";

const truncateText = (str, max = 25) => {
  if (!str) return "";
  return str.length > max ? str.substring(0, max) + "..." : str;
};

const TaskList = () => {
  // let data = "";
  const apiCall = useApiCall();

  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});

  return (
    <>
      <div className="pt-[20px] overflow-hidden h-full">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          <TableCard className={"!p-[15px]  h-full overflow-hidden"}>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 ">
              <div className="col-span-1 md:col-span-3  min-h-400 py-[15px] px-[10px]  border border-[#E1E4EA] shadow rounded-[10px] overflow-hidden">
                <div className="flex flex-col gap-y-5">
                  <div className="flex flex-col gap-y-3">
                    <p className="text-sm font-normal text-[rgba(14,18,27,0.60)]">
                      PPC Team
                    </p>
                    <p className="text-[18px] font-semibold ">Subhan Ali</p>
                    <p className="text-sm font-normal text-[rgba(14,18,27,0.60)]">
                      subhan1972
                    </p>
                    <div className="flex gap-4 items-center">
                      <p className="text-sm font-normal text-[rgba(14,18,27,0.60)]">
                        Ui/Ux Developer
                      </p>
                      <a
                        href="mailto:abc@gmail.com"
                        className="text-sm font-normal text-[rgba(14,18,27,0.60)] transition-all duration-200 hover:text-gray-600 hover:underline hover:font-medium"
                      >
                        abc@gmail.com
                      </a>
                    </div>
                  </div>
                  <div className="flex flex-col gap-y-5 justify-between ">
                    <div className="flex justify-between items-center gap-4">
                      <div className=" rounded-[10px] border border-[#E1E4EA] shadow p-4 flex flex-col gap-4 w-full">
                        <p className="text-sm font-normal text-[rgba(14,18,27,0.60)]">
                          Assign Tasks
                        </p>
                        <div className="flex justify-between items-center">
                          <p className="text-3xl font-semibold">4</p>
                          <p className="text-[#5FE0EF]">
                            <ThumbsUp size={36} />
                          </p>
                        </div>
                      </div>
                      <div className=" rounded-[10px] border border-[#E1E4EA] shadow p-4 flex flex-col gap-4 w-full">
                        <p className="text-sm font-normal text-[rgba(14,18,27,0.60)]">
                          Completed Tasks
                        </p>
                        <div className="flex justify-between items-center">
                          <p className="text-3xl font-semibold">8</p>
                          <p className="text-[#BF83FF]">
                            <NotebookText size={36} />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between items-center gap-4">
                      <div className=" rounded-[10px] border border-[#E1E4EA] shadow p-4 flex flex-col gap-4 w-full">
                        <p className="text-sm font-normal text-[rgba(14,18,27,0.60)]">
                          Assign Projects
                        </p>
                        <div className="flex justify-between items-center">
                          <p className="text-3xl font-semibold">9</p>
                          <p className="text-[#5FE0EF]">
                            <ThumbsUp size={36} />
                          </p>
                        </div>
                      </div>
                      <div className=" rounded-[10px] border border-[#E1E4EA] shadow p-4 flex flex-col gap-4 w-full">
                        <p className="text-sm font-normal text-[rgba(14,18,27,0.60)]">
                          Completed Projects
                        </p>
                        <div className="flex justify-between items-center">
                          <p className="text-3xl font-semibold">3</p>
                          <p className="text-[#BF83FF]">
                            <NotebookText size={36} />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="col-span-1 md:col-span-9 grid grid-cols-1 md:grid-cols-12 gap-6   place-items-center  p-5  bg-[#E1E4EA] rounded-[10px] overflow-hidden">
                {[1, 2, 3, 4].map((i) => {
                  return (
                    <div key={i} className="col-span-3  gap-6 w-full ">
                      <motion.div
                        whileHover={{ scale: 1.01, y: 0 }}
                        whileTap={{ scale: 0.99 }}
                        className="flex p-4 rounded-lg border border-[#E1E4EA] bg-[#fff] transition-all duration-300 "
                        style={{
                          boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.10)",
                        }}
                      >
                        <div className=" w-full flex flex-col gap-4">
                          

                          <div className="flex flex-col gap-2">
                            <div className="flex items-start justify-between">
                              <div className="flex-1 min-w-0">
                                <h4
                                  className={`font-normal text-[rgba(14,18,27,0.60)] text-sm leading-tight truncate`}
                                >
                                  Project
                                </h4>
                              </div>
                            </div>

                            <div className="text-[18px] text-[#0E121B] font-semibold">
                              {truncateText("Test", 25)}
                            </div>
                          </div>

                          
                          <div className="flex flex-col">
                            <div className="flex justify-between items-center py-[10px]">
                              <span
                                className={`font-medium text-[rgba(14,18,27,0.60)] text-sm leading-tight truncate`}
                              >
                                Status
                              </span>
                              <span
                                className={`py-1 px-[10px] rounded-2xl text-white text-xs `}
                                style={{ backgroundColor: "#335CFF" }}
                              >
                                20 Tasks
                              </span>
                            </div>
                            <div className="py-[10px] px-[14px]  border border-[#E1E4EA] bg-[#F3F3F3] rounded-[5px] flex justify-center items-center">
                              <div className="flex flex-col justify-center items-center gap-4 w-full text-center">
                                <span className="font-semibold text-[rgba(14,18,27,0.60)] text-[10px] leading-tight">
                                  In Process
                                </span>
                                <span className="text-3xl text-[#0E121B] font-semibold">
                                  5
                                </span>
                              </div>
                              <div
                                className="h-full  w-1"
                                style={{ backgroundColor: "#335CFF" }}
                              ></div>
                              <div className="flex flex-col justify-center items-center gap-4 w-full text-center">
                                <span className="font-semibold text-[rgba(14,18,27,0.60)] text-[10px] leading-tight">
                                  Completed
                                </span>
                                <span className="text-3xl text-[#0E121B] font-semibold">
                                  12
                                </span>
                              </div>
                            </div>
                          </div>

                          
                          <div>
                            <div className="flex justify-between items-center">
                              <p
                                className={`text-[rgba(14,18,27,0.60)] text-sm leading-tight font-medium `}
                              >
                                Project Details:
                              </p>
                            </div>
                            <div className="flex gap-1 mt-1 text-sm leading-tight font-medium text-[#0E121B]">
                              <p>Peter Parker</p>
                              <p className="border-l-2 pl-2">PPC Team</p>
                            </div>

                           

                            <div className="flex justify-between items-center py-[10px]">
                              <div>
                                <StatusChip
                                  color={
                                    "completed" == "completed"
                                      ? "green"
                                      : "pending" == "pending"
                                      ? "blue"
                                      : "red"
                                  }
                                >
                                  Pending
                                </StatusChip>
                              </div>

                              <button
                                className="group flex items-center  transition-all duration-200 gap-[2px]"
                                // onClick={() => {
                                //   setEmpPopup(true);
                                //   setEmpData(lead);
                                // }}
                              >
                                <span className="underline  text-sm bg-transparent  font-semibold">
                                  See Details
                                </span>

                              
                                <span className=" group-hover:translate-x-1 transition-transform duration-200  font-semibold">
                                  <ChevronRight />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </div>
                  )
                })} 

                
              </div> */}

              <div className="col-span-1 md:col-span-9 p-4 bg-[#E1E4EA] rounded-[10px] ">
                <DragCarousel/>
              </div>

              <div className="col-span-1 md:col-span-12  p-5 min-h-[400px] max-h-[450px] border border-[#E1E4EA] shadow rounded-[10px] overflow-hidden">
                <div className="flex items-center justify-between  overflow-hidden">
                  Deals
                  <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                    <DotsVerticalIcon />
                  </div>
                </div>

                <DealList />
              </div>
            </div>
          </TableCard>
        </div>
      </div>

      {empPopup && (
        <ProjectQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
        />
      )}
    </>
  );
};

export default TaskList;
